import {
  Avatar,
  BorderRadiusCorners,
  Box,
  Skeleton,
  Text,
} from '@factorialco/deprecated-design-system'
import { ShiftManagementSwapShiftEmployeeBlockDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  accessId: string
}

const EmployeeBlock = ({ accessId }: Props) => {
  const { data, loading } = useQuery(ShiftManagementSwapShiftEmployeeBlockDocument, {
    variables: { accessIds: [accessId] },
  })

  const employee = data?.employees?.employeesConnection.nodes[0]
  const referenceContract = employee?.referenceContract

  const jobTitle = referenceContract?.jobTitle
  const levelName = referenceContract?.jobCatalogLevel?.name
  const roleName = referenceContract?.jobCatalogLevel?.roleName

  const fullName = employee?.fullName || ''

  const borderRadius: BorderRadiusCorners = {
    all: 'abs008',
  }

  if (loading) return <Skeleton width="full" height="s80" isLoading />

  return (
    <>
      <Box
        flexDirection="row"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={borderRadius}
        padding="s16"
        width="full"
      >
        <Box flexDirection="row" gap="s16" alignItems="center">
          <Box flexDirection="column">
            <Avatar size="s32" url={buildUrl(employee?.avatar?.url)} label={fullName} />
          </Box>
          <Box flexDirection="column">
            <Text size="300" weight="semibold" color="grey1000">
              {fullName}
            </Text>
            <Text size="200" weight="normal" color="grey1000">
              {jobTitle || `${roleName} - ${levelName}`}
            </Text>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default EmployeeBlock
